import { store } from 'react-easy-state'

const _store = store({
  notifyDate: '',
  notifyChannel: '',
  accidentDateTime: '',
  accidentPlace: '',
  accidentPlaceOther: '',
  latitude: '',
  longitude: '',
  driverPreName: '',
  driverFName: '',
  driverLName: '',
  driverPhone: '',
  notifyPreName: '',
  notifyFName: '',
  notifyLName: '',
  notifyPhone: '',
  insureCarLicense: '',
  insureCarLicenseProvince: '',
  vmiPolicyNumber: '',
  cmiPolicyNumber: '',
  lineReferenceId: '',
  appointPlace: '',
  appointLatitude: '',
  appointLongitude: '',
  useAccidentLocation: '',
  flagParties: '',
  polStartDate: '',
  polEndDate: '',

  setUserInformation(
    notifyChannel: string,
    notifyPreName: string,
    notifyFName: string,
    notifyLName: string,
    notifyPhone: string,
    insureCarLicenseProvince: string,
    vmiPolicyNumber: string,
    cmiPolicyNumber: string,
    lineReferenceId: string,
    polStartDate: string,
    polEndDate: string
  ) {
    _store.notifyChannel = notifyChannel
    _store.notifyPreName = notifyPreName
    _store.notifyFName = notifyFName
    _store.notifyLName = notifyLName
    _store.notifyPhone = notifyPhone
    _store.insureCarLicenseProvince = insureCarLicenseProvince
    _store.vmiPolicyNumber = vmiPolicyNumber
    _store.cmiPolicyNumber = cmiPolicyNumber
    _store.lineReferenceId = lineReferenceId
    _store.polStartDate = polStartDate
    _store.polEndDate = polEndDate
  },

  setNewUserInformation(
    driverPreName: string,
    driverFName: string,
    driverLName: string,
    driverPhone: string,
    insureCarLicense: string
  ) {
    _store.driverPreName = driverPreName
    _store.driverFName = driverFName
    _store.driverLName = driverLName
    _store.driverPhone = driverPhone
    _store.insureCarLicense = insureCarLicense
  },

  setMakeClaim(
    accidentDateTime: string,
    accidentPlace: string,
    latitude: string,
    longitude: string,
    accidentPlaceOther: string,
    flagParties: string
  ) {
    _store.accidentDateTime = accidentDateTime
    _store.accidentPlace = accidentPlace
    _store.latitude = latitude
    _store.longitude = longitude
    _store.accidentPlaceOther = accidentPlaceOther
    _store.flagParties = flagParties
  }
})

export default _store
